<footer class="footer">
    <div class="container-fluid">
      <div class="p-fluid p-formgrid p-grid" style="margin-top: 24px;">
         <div class="p-field p-col-6">
          <a href="http://www.tjro.jus.br" style="color: #666">Tribunal de Justiça do Estado de Rondônia - TJRO</a>
        </div>
        <div class="p-field p-col-6 p-text-right">
          &copy; {{aplicacao.nome}} - <a routerLink="/aplicacao" title="{{aplicacao.commitSha}}">{{aplicacao.versao}} - {{aplicacao.dataCompilacao}}</a>
        </div>
      </div>
    </div>
</footer>



